module.exports = __webpack_public_path__ + "static/media/Close.b4200bd3.svg";